belimo-svg-sprite {
  display: inline-flex;
  vertical-align: center;
  .svg-sprite {
    display: inline-flex;
    cursor: inherit;
    vertical-align: middle;
    flex-flow: row;
    -webkit-align-content: center;
    -ms-flex-line-pack: center;
    align-content: center;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: inherit;
    //border: 1px red solid;
    * {
      fill: currentColor;
    }
  }
}
